import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import SiteLayout from "../components/feature/SiteLayout";
import Home from "../pages/home/page";
import Rank from "../pages/rank/page";
import Category from "../pages/category/page";
import TopicDetail from "../pages/topic/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    element: <SiteLayout />,
    children: [
      {
        path: "/",
        element: <Home />,
      },
      {
        path: "/rank",
        element: <Rank />,
      },
      {
        path: "/category/:slug",
        element: <Category />,
      },
      {
        path: "/topic/:id",
        element: <TopicDetail />,
      },
      {
        path: "/about",
        element: <About />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;